import { trace } from 'rytm-helpers'

export const updateFullBgHeight = () => {
  const ifh = document.querySelector(".item-full-header.has-image.full-size, .modcahomeslide-slide");
  const bgmw = ifh ? ifh.querySelector(".bg-media-wrapper") : null
  if (bgmw) {
    bgmw.style.height = ifh.offsetHeight + "px";
  }
}